// The active-template context, brand-free so the host (entry bundle) doesn't
// pull the colour solver in. Templates import ./context, which re-exports
// these plus the brand hooks.

import { createContext, useContext } from 'react'
import type { RawOptions } from './options'
import type { SiteTemplate, SiteTemplateManifest } from './types'

export interface SiteTemplateContextValue {
  manifest: SiteTemplateManifest
  template: SiteTemplate
  /** Resolved (defaults filled, unknown keys dropped). */
  options: RawOptions
}

export const SiteTemplateContext = createContext<SiteTemplateContextValue | null>(null)

/** The active template. Throws outside SiteTemplateHost (and the workbench). */
export function useSiteTemplate(): SiteTemplateContextValue {
  const ctx = useContext(SiteTemplateContext)
  if (!ctx) throw new Error('useSiteTemplate must be used inside SiteTemplateHost')
  return ctx
}

/** The active template, or null outside SiteTemplateHost (controllers under renderHook, kit tests). */
export function useOptionalSiteTemplate(): SiteTemplateContextValue | null {
  return useContext(SiteTemplateContext)
}
